import DesignEditorHeader from './DesignEditorHeader';
import DesignEditorHeaderCenterSlot from './DesignEditorHeaderCenterSlot';
import DesignEditorHeaderLeftSlot from './DesignEditorHeaderLeftSlot';
import DesignEditorHeaderRightSlot from './DesignEditorHeaderRightSlot';

export {
  DesignEditorHeaderLeftSlot,
  DesignEditorHeaderCenterSlot,
  DesignEditorHeaderRightSlot,
};
export default DesignEditorHeader;
